import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Banknote, CreditCard, RefreshCw, type LucideIcon } from "lucide-react";
import { fadeUp, stagger, viewportOnce } from "./motion-presets";

const CHIPS: Array<{ key: string; icon: LucideIcon }> = [
  { key: "methods", icon: CreditCard },
  { key: "bank", icon: Banknote },
  { key: "quickbooks", icon: RefreshCw },
];

export const PaymentsSection = () => {
  const { t } = useTranslation("landing");
  return (
    <section id="payments" className="relative py-24 px-4">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={stagger}
        className="container mx-auto max-w-3xl text-center"
      >
        <motion.span
          variants={fadeUp}
          className="text-xs font-medium uppercase tracking-wider text-muted-foreground"
        >
          {t("payments.eyebrow")}
        </motion.span>
        <motion.h2
          variants={fadeUp}
          className="mt-3 font-display text-3xl md:text-5xl font-semibold tracking-tight text-foreground"
        >
          {t("payments.title")}
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-5 text-muted-foreground leading-relaxed">
          {t("payments.body")}
        </motion.p>

        <motion.div variants={fadeUp} className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
          {CHIPS.map(({ key, icon: Icon }) => (
            <span
              key={key}
              className="inline-flex items-center gap-2 rounded-full border border-border bg-card/40 px-3.5 py-1.5 text-xs text-foreground/80"
            >
              <Icon className="h-3.5 w-3.5 text-primary" />
              {t(`payments.chips.${key}`)}
            </span>
          ))}
        </motion.div>

        <motion.p variants={fadeUp} className="mt-6 text-xs font-medium uppercase tracking-wider text-primary">
          {t("payments.note")}
        </motion.p>
      </motion.div>
    </section>
  );
};
